import { type ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useRoles } from '@/hooks/use-roles';
import type { Role } from '@/lib/user-roles';
import { ROUTES } from '@/lib/routes';
import { PageSkeleton } from '@/app/components/PageSkeleton';

interface RequireRoleProps {
  role: Role;
  children: ReactNode;
}

export function RequireRole({ role, children }: RequireRoleProps) {
  const { roles, isLoading } = useRoles();

  if (isLoading) return <PageSkeleton />;
  if (!roles.includes(role)) {
    return <Navigate to={ROUTES.NOT_FOUND} replace />;
  }

  return <>{children}</>;
}
